import { array, func } from 'prop-types';
import React from 'react';
import { FMessage } from '../../hoc/IntlComponents';
import CustomTable from '../CustomTable/CustomTable';
import FlowsListItem from './FlowsListItem';

const propTypes = {
  flows: array.isRequired,
  onFlowRemove: func.isRequired,
  onFlowCopy: func.isRequired,
};

const defaultProps = {
  flows: [],
};

const FlowsList = ({ flows, onFlowRemove, sortOrder, sortBy, handleSort, onFlowCopy }) => {
  return (
    <CustomTable className="flows-list" bordered responsive stripped aria-label="Flows">
      <CustomTable.Wrapper>
        <CustomTable.Row>
          <CustomTable.Cell
            sortBy={sortBy}
            sortOrder={sortOrder}
            sortName="id"
            handleSort={handleSort}
            defaultSortOrder="desc"
            sorting
          >
            ID
          </CustomTable.Cell>
          <CustomTable.Cell
            sortBy={sortBy}
            sortOrder={sortOrder}
            sortName="title"
            handleSort={handleSort}
            defaultSortOrder="desc"
            sorting
          >
            <FMessage id="flows.table.title" />
          </CustomTable.Cell>
          <CustomTable.Cell
            sortBy={sortBy}
            sortOrder={sortOrder}
            sortName="its"
            handleSort={handleSort}
            defaultSortOrder="desc"
            sorting
          >
            <FMessage id="flows.table.added" />
          </CustomTable.Cell>
          <CustomTable.Cell>
            <FMessage id="flows.table.click-link" />
          </CustomTable.Cell>
          {/* <CustomTable.Cell
            sortBy={sortBy}
            sortOrder={sortOrder}
            sortName='title'
            handleSort={handleSort}
            defaultSortOrder='desc'
            sorting>
            
          </CustomTable.Cell> */}
          {/* <CustomTable.Cell
            sortBy={sortBy}
            sortOrder={sortOrder}
            sortName='type'
            handleSort={handleSort}
            defaultSortOrder='desc'
            sorting>
            <FMessage id="flows.table.type" />
          </CustomTable.Cell> */}
          <CustomTable.Cell
            sortBy={sortBy}
            sortOrder={sortOrder}
            sortName="offerTitle"
            handleSort={handleSort}
            defaultSortOrder="desc"
            sorting
          >
            <FMessage id="flows.table.offer" />
          </CustomTable.Cell>

          <CustomTable.Cell />
          <CustomTable.Cell className="table-controls" />
          <CustomTable.Cell className="table-controls" />
          <CustomTable.Cell className="table-controls" />
          <CustomTable.Cell className="table-controls" />
        </CustomTable.Row>
      </CustomTable.Wrapper>

      {flows.length > 0 && (
        <CustomTable.Wrapper type="body">
          {flows.map((flow) => (
            <FlowsListItem
              key={flow.id}
              {...flow}
              onFlowRemove={onFlowRemove}
              onFlowCopy={onFlowCopy}
              count={flows.length}
            />
          ))}
        </CustomTable.Wrapper>
      )}
    </CustomTable>
  );
};

FlowsList.propTypes = propTypes;
FlowsList.defaultProps = defaultProps;

export default FlowsList;
